module.exports = __webpack_public_path__ + "static/media/aq.03488506.webp";